/* istanbul ignore file */
// eslint-disable-next-line nebula-rules/check-exist-test-file
export const redirectToUrl = (url: string) => {
  return window.location.replace(url);
};
